import { ReactNode, useEffect, useState } from 'react';
import style from './style.module.scss';
import NavigationBar, { NavigationBarProps } from '../navigation-bar';
import { motion } from 'framer-motion';
import { useStore } from '../../lib/hooks/useStore';
import { observer } from 'mobx-react-lite';
import ReceiptPrint from '../receipt-print';
import LoaderScreen from '../loader-screen';
import utilityStyle from '../../styles/scss/helpers/utilities.module.scss';
import SessionCountdown from '../session-timer-warning';

export interface LayoutProps {
	logoProps: AppImageProps;
	mainContent?: ReactNode;
	footerContent?: ReactNode;
	navProps: NavigationBarProps;
}

const Layout = observer(function Layout({
	logoProps: { src, alt, className: logoClasses, ...logoProps },
	mainContent,
	footerContent,
	navProps,
}: LayoutProps) {
	const {
		uiStore: { title, receiptMounted, showModal, isLoaderActive, screenLogoPath, isNavCollapsed },
		sessionStore: { isShowingCountdown },
	} = useStore();
	const [contentStyle, setcontentStyle] = useState<string[]>([style.main__content, style.content]);
	useEffect(() => {
		if (showModal) setcontentStyle([style.main__content, style.content, style['main__content--modal']]);
		else setcontentStyle([style.main__content, style.content]);

		return () => {
			setcontentStyle([style.main__content, style.content]);
		};
	}, [showModal]);

	return (
		<>
			<div className={[style.layout, 'screen-only'].join(' ')} key={title}>
				<div className={[style.layout__app].join(' ')}>
					<header className={style.header}>
						<img src={screenLogoPath || src} alt={alt} className={[style.header__logo, logoClasses].join(' ')} {...logoProps} />
					</header>
					<main className={style.main}>
						{showModal && <div className={style.main__modal}></div>}
						<motion.div className={contentStyle.join(' ')}>
							{isLoaderActive && <LoaderScreen />}
							<h1 className={[style.content__title, isLoaderActive || isShowingCountdown ? utilityStyle['u-hidden'] : ''].join(' ')}>
								{title}
							</h1>
							<div
								className={[style.content__component, isLoaderActive || isShowingCountdown ? utilityStyle['u-hidden'] : ''].join(' ')}
							>
								{mainContent}
							</div>
							{isShowingCountdown && <SessionCountdown />}
						</motion.div>
					</main>
					{!showModal && !isShowingCountdown && !isNavCollapsed && <NavigationBar {...navProps} className={style.nav} />}
				</div>
				<footer className={[style.layout__footer].join(' ')}>{footerContent}</footer>
			</div>
			{receiptMounted && <ReceiptPrint />}
		</>
	);
});

export default Layout;
